var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppBarSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3864 18.4232C22.2045 19.2416 22.2045 20.5684 21.3864 21.3864C20.5684 22.2045 19.2416 22.2045 18.4232 21.3864L14.0989 17.0622C13.7927 16.7556 13.2377 16.6782 12.8519 16.8843C12.8519 16.8843 12.9045 16.8718 12.5669 17.0242C11.4499 17.5288 10.2102 17.8098 8.90507 17.8098C3.98704 17.8098 0 13.8227 0 8.90507C0 3.98704 3.98704 0 8.90507 0C13.8227 0 17.8098 3.98704 17.8098 8.90507C17.8098 10.2146 17.527 11.4584 17.0191 12.5783C16.8678 12.9115 16.8832 12.8549 16.8832 12.8549C16.6756 13.2356 16.756 13.7928 17.0622 14.099L21.3864 18.4232ZM8.90478 13.8811C11.6528 13.8811 13.8809 11.653 13.8809 8.90495C13.8809 6.15654 11.6528 3.92847 8.90478 3.92847C6.15636 3.92847 3.92829 6.15654 3.92829 8.90495C3.92829 11.653 6.15636 13.8811 8.90478 13.8811Z",
    fill: "#2F696D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBarSearch);
export default __webpack_public_path__ + "static/media/AppBarSearch.a621459521cd7fbc71b43e217cf52852.svg";
export { ForwardRef as ReactComponent };